export default __webpack_public_path__ + "static/media/ico_notification_blue.b705269a.svg";